import { Button, Container, Divider, Fade, Grow, MobileStepper, Step, StepLabel, Stepper, Typography, useMediaQuery, Zoom } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Form from '../../Form/Form';
import EditProfilePictureScreen from './EditProfilePictureScreen';
import IntroEditScreen from './IntroEditScreen';
import styles from './styles'; 
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import theme from '../../../muiTheme';
import { GoAlert } from "react-icons/go";
import EditBio from './EditBio';
import WhoToFollow from './WhoToFollow';
import { editProfile } from '../../../actions/auth';
import EditAll from './EditAll';

const useQuery = () => {

    let location = useLocation();

    return new URLSearchParams(location.search);
}

const EditProfile = ({newUser}) => {

    //profile and new user will be obtained from query

    const authStateSlice = useSelector((state) => state.authReducer);
    //if new user, take them on a journey
    const [journeyStage, setJourneyStage] = useState(0);
    const [isEditAll, setIsEditAll] = useState(false);
    const [newProfile, setNewProfile] = useState(null);
    const query = useQuery();  
    const isMobile = useMediaQuery('(max-width: 768px)');
    const navigate = useNavigate();
    const dispatch = useDispatch(); 

    useEffect(()=>{

        if(authStateSlice?.authData?.result){
            setNewProfile(authStateSlice?.authData.result);
        }

        console.log('authStateSlice result: ', authStateSlice);

        let queryStage = query ? query.get('stage') : null;

        if(queryStage){
            
            console.log('query stage?: ', queryStage);

            //set stage to query value
            setJourneyStage(parseInt(queryStage));
        }else {

            //user already completed or skipped onboarding -- set stage to edit whole profile page (TODO)
            setIsEditAll(true);
        }
    
        return () => {
            
        }

    },[]);

    //if not new user, then they don't need to go through a journey
    useEffect(() => {

        if(authStateSlice?.authData?.result){
            setNewProfile(authStateSlice?.authData.result);
        }

        console.log('authStateSlice result: ', authStateSlice);
    
        return () => {
            
        }

    }, [authStateSlice]);
    

    let onStageCompleted = (modifiedProfile, stage) => {

        console.log('New profile: ', newProfile);

        console.log('-------onStageCompleted called, modified profile: ', modifiedProfile, ' stage: ', stage);

        console.log('About to go through the switch');

        switch(stage){

            case 0:

                setJourneyStage(1); 

                break;
            
            case 1:

                //check if modified profile has picture
                if(modifiedProfile?.selectedFile && modifiedProfile.selectedFile.type.includes('image')){

                    setSteps((prevSteps)=>{

                        let newSteps = [...prevSteps];
                        newSteps[1].complete = true; 

                        return newSteps; 
                    });

                    setNewProfile(modifiedProfile);

                    setJourneyStage(2);

                }else {

                    //print error here
                    
                }

                

                break;

            case 2:

                console.log('Case stage 2');

                setSteps((prevSteps)=>{

                    let newSteps = [...prevSteps];
                    newSteps[2].complete = true; 

                    console.log('New steps: ', newSteps);

                    return newSteps; 
                });

                setNewProfile(modifiedProfile);

                setJourneyStage(3);

                break;

            case 3:

                //save details to API

                console.log('Stage 3 complete, modifiedProfile: ', modifiedProfile, ' newProfile: ', newProfile);

                let url = '/'; 

                dispatch(editProfile(modifiedProfile, navigate, url)); 
                

                //navigate to /profile

                break;

            default:

                console.log('default case');

                break; 

        }

        console.log('Skipped the swicth statement??????');

    }

    const initialSteps = [
        {
            label: 'Create New Account',
            complete: true,
            error: 'Account not created',
            props: {
                onCompleted: onStageCompleted
            }
        },
        {
            label: 'Add Profile Picture',
            complete: false,
            error: 'No profile picture uploaded',
            props: {
                onCompleted: onStageCompleted,
                onFail: false
            }
        },
        {
            label: 'Create Bio',
            complete: false,
            error: 'No Bio :(',
            props: {
                onCompleted: onStageCompleted,
                onFail: false,
            }
        },
        {
            label: 'Follow some users',
            complete: false,
            error: 'Not following anyone',
            props: {
                onCompleted: onStageCompleted,
                onFail: false
            }
        },
        // {
        //     label: 'Verify Email',
        //     complete: false,
        //     error: 'You\'re not verified yet',
        //     props: {
        //         onCompleted: onStageCompleted,
        //         onFail: false
        //     }
        // },
    ]

    const [steps, setSteps] = useState(initialSteps);


    const Stages = [

        <IntroEditScreen {...steps[0].props} profile={newProfile}/>,
        <EditProfilePictureScreen {...steps[1].props} profile={newProfile}/>,
        <EditBio {...steps[2].props} profile={newProfile} isMobile={isMobile} />,
        <WhoToFollow {...steps[3].props} profile={newProfile} isMobile={isMobile} />
    ]; 

    const navigateToStage = (stage) => {

        

        setJourneyStage(stage);
    }

    if(authStateSlice?.authData == null){

        return (
            <Box
                sx={styles.rootContainer}
            >

                <Typography>
                    Oops! Something has gone wrong. 
                </Typography>

            </Box>
        );
    }


    const journeyContent = ( 
            <>
            
                <Container
                    sx={styles.rootContainer}
                    className='edit-profile-container'
                >

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100vw',
                            marginTop: '0px',
                            flex: 1,
                            position: 'sticky',
                            top: isMobile ? '0px' :'30px',
                            padding: isMobile? '0px 0px' : '50px 0px',
                            paddingBottom: '10px',
                            background: isMobile ? 'transparent' : 'white',
                            zIndex: '100'
                        }}
                    >
                        <Typography variant='body1' className='progress-title'>
                            Account Setup

                        </Typography>

                        {
                            !isMobile &&

                            <Box

                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                padding: '0px 0px',
                                background: 'white'
                            }}
                            
                            >

                                <Stepper activeStep={journeyStage} sx={{width: '100%'}} alternativeLabel>
                                    {steps.map((step, index) => {

                                        const labelProps = {
                                            sx: {
                                                fontWeight: index === journeyStage ? 'bold' : 'normal'
                                            }
                                        };

                                        if(journeyStage > index && !step.complete){
                                            labelProps.optional = (
                                                <Typography variant="caption" color="error" sx={{textAlign: 'center'}}>
                                                {step.error}
                                                </Typography>
                                            )

                                            labelProps.icon = <GoAlert style={{fontSize: '26px'}}/>

                                            labelProps.sx = {textAlign: 'center', color: theme.palette.error.main, '& .Mui-completed': {textDecoration: 'line-through'}}
                                        }

                                        return (
                                            <Step key={step.label} onClick={()=>navigateToStage(index)} sx={{cursor: 'pointer'}}>
                                                <StepLabel {...labelProps} >{step.label}</StepLabel>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </Box>
                        }
                        

                    </Box>

                    

                    <Box
                        sx={{
                            width: '100%',
                            position: 'relative',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flex: 20
                        }} 
                    >
                        {Stages[journeyStage]}
                    </Box>
                    
                    

                </Container>

                <Box
                    className='edit-progress-tracker'
                    sx={styles.progressTracker}
                >

                    <Box className='inner-progress-container'>

                        {isMobile &&
                        
                    
                            <MobileStepper
                                variant="progress"
                                steps={6}
                                position="static"
                                activeStep={journeyStage}
                                sx={{ maxWidth: 400, flexGrow: 1 }}
                                nextButton={
                                <Button size="small" onClick={()=>setJourneyStage(i=>i+1)} disabled={journeyStage === steps.length}>
                                    Next
                                    {theme.direction === 'rtl' ? (
                                    <KeyboardArrowLeft />
                                    ) : (
                                    <KeyboardArrowRight />
                                    )}
                                </Button>
                                }
                                backButton={
                                <Button size="small" onClick={()=>setJourneyStage(i=>i-1)} disabled={journeyStage === 0}>
                                    {theme.direction === 'rtl' ? (
                                    <KeyboardArrowRight />
                                    ) : (
                                    <KeyboardArrowLeft />
                                    )}
                                    Back
                                </Button>
                                }
                            />
                    
                    
                        

                            
                        }
                        
                    </Box>

                </Box>
            </>
    );


    const editAll = (

        <Container
                    sx={styles.rootContainer}
                    className='edit-profile-container'
                >

            <EditAll profile={newProfile} isMobile={isMobile} />

        </Container>
    );
        


    return (
        <>

            {
                isEditAll ?

                 editAll

                 :

                 journeyContent
            }
        
        </>
    );
}

export default EditProfile; 